import countries from '../../countries.json';

// This check is quite naive, but that's fine according to the business rules.
export default class ArticleCheck {
	constructor(el) {
		this.el = el;
		this.id = 'article-' + document.body.className.match(/postid-(\d+)/)?.[1];
		this.query;
		this.perPage;
		this.search = el?.querySelector('.filter-countries');
		this.countriesWrapper = el?.querySelector('.countries');
		this.postId = document.body.className.match(/postid-(\d+)/)?.[1];
		this.notAllowed = el?.querySelector('.not-allowed');
		this.agree = el?.querySelector('.disclaimer-agree');
		this.disagree = el?.querySelector('.disclaimer-disagree');

		if (localStorage.getItem(this.id) === 'true') {
			return this.abort();
		}

		this.agree?.addEventListener('click', () => {
			this.abort();
			localStorage.setItem(this.id, true);
		});

		this.disagree?.addEventListener('click', () => {
			this.notAllowed?.classList.remove('hidden');
		});

		try {
			this.restrictedCountries = JSON.parse(this.el?.getAttribute('data-countries'));
			if (this.restrictedCountries.length === 0) {
				return this.abort();
			}
		} catch {
			return this.abort();
		}

		if (!this.postId || !!localStorage.getItem('article-' + this.postId)) {
			// Either unexpected, or the user has already been approved.
			// Abort the check altogether.
			return this.abort();
		}

		this.renderCountries(this.query, this.perPage);

		this.el?.classList.remove('hidden');
		this.switchStep(1);

		this.search.addEventListener('input', (e) => {
			this.renderCountries(e.target.value, this.perPage);
		});
	}

	abort() {
		document.querySelector('.article-check')?.classList.add('hidden');
		document.querySelector('.page-content')?.classList.remove('hidden');
	}

	renderCountries(query = '', perPage = 6) {
		query = query.toLowerCase();
		let filteredCountries = Object.entries(countries)
			.filter(([_, name]) => name.toLowerCase().includes(query))
			.sort((a, b) => a[1].localeCompare(b[1]));

		let results = filteredCountries.slice(0, perPage);
		const hasMore = filteredCountries.length > perPage;

		results = [...results, ...(hasMore ? [null] : [])].map((data) => {
			const node = document.createElement('button');
			node.setAttribute(
				'class',
				'border-1 max-lg:text-sm border-green rounded-full p-2 pr-4 flex flex-row-reverse items-center gap-3 font-bold cursor-pointer hover:bg-light-green'
			);
			node.style.justifyContent = 'start';

			if (data === null) {
				node.textContent = strl_vars.load_more;

				const loadMoreImg = document.createElement('img');
				loadMoreImg.src = strl_vars['stylesheet_directory'] + '/assets/img/load-more.svg';
				loadMoreImg.setAttribute('class', 'size-10');

				node.appendChild(loadMoreImg);

				node.addEventListener('click', () => {
					this.renderCountries(query, perPage + 6);
				});

				return node;
			}

			const [code, name] = data;

			node.textContent = name;

			const flag = document.createElement('img');
			flag.src = `https://flagcdn.com/h40/${code.toLowerCase()}.png`;
			flag.setAttribute('class', 'size-10 rounded-full object-center object-cover');

			node.appendChild(flag);
			node.addEventListener('click', () => {
				if (!this.restrictedCountries.includes(code)) {
					this.el?.querySelector('.step-1')?.classList.add('hidden');
					this.el?.querySelector('.step-2')?.classList.remove('hidden');
				} else {
					this.notAllowed?.classList.remove('hidden');
				}
			});

			return node;
		});

		this.countriesWrapper?.replaceChildren(...results);
	}

	switchStep(number) {
		document.querySelectorAll('.step-1, .step-2').forEach((step) => step.classList.add('hidden'));
		document.querySelector('.step-' + number)?.classList.remove('hidden');
	}
}
